import { getTenant } from '@/helpers/tenant'

import packageJson from '../../package.json'

export const localStorageApiTokenKey = 'apiToken'

interface RequestInitExtraOptions extends RequestInit {
    disableContentType?: boolean
}

export const authorizedFetch = async (url: string, options?: RequestInitExtraOptions): Promise<Response> => {
    const optionsWithToken: RequestInit = {
        ...options,
        headers: {
            Accept: 'application/vnd.api+json',
            TENANT: getTenant(),
            ...(! options?.disableContentType && { 'Content-Type': 'application/vnd.api+json' }),
            ...options?.headers,
        },
    }

    const apiToken = localStorage.getItem(localStorageApiTokenKey)

    if (apiToken) {
        optionsWithToken.headers = {
            ...optionsWithToken.headers,
            Authorization: `Bearer ${apiToken}`,
            TENANT: getTenant(),
            App: 'timer',
            'App-Version': packageJson.version,
        }
    }

    const response = await fetch(url, optionsWithToken)

    if (response.status === 401) {
        return Promise.reject({
            response,
        })
    }

    return response
}
